/* eslint-disable camelcase */
import React from 'react';
import { ColorBatch } from 'components';
import { actionSearchTypesName, actionSearchTypesColorMap, dateTimeFormat } from 'enums';
import { jsx as ___EmotionJSX } from "@emotion/react";
export var actionsListColumns = [{
  name: 'Дата',
  value: 'created_at',
  dateTimeFormat: dateTimeFormat,
  width: '120px'
}, {
  name: 'Действие',
  render: function render(_ref) {
    var action = _ref.action;
    return ___EmotionJSX(ColorBatch, {
      type: actionSearchTypesColorMap[action]
    }, actionSearchTypesName[action]);
  },
  width: '120px'
}, {
  name: 'Описание',
  value: 'note'
}, {
  name: 'Служител',
  value: 'employee.name',
  width: '160px'
}];